const CityDotWrap = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 3;
  pointer-events: none;
`;
import { INTRO_TEXT, INTRO_STATS, CITY_GROUPS } from "appLauncher";
import styled from "styled-components";
import { SectionTitle, SectionSubtitle } from "components/Style";

const CitiesSection = styled.section`
  background-image: url(/assets/home/bar-background-3.png);
  background-position: center;
  color: #fff;
  padding: 65px 0;
  overflow: hidden;
  .white-text {
    color: #fff;
  }
`;

const CitiesContainer = styled.div`
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 20px;
`;

const CityMap = styled.div`
  width: 841px;
  height: 617px;
  max-width: 100%;
  margin-bottom: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: auto;
  margin-right: auto;
  position: relative;
  background-image: url(/assets/home/china.png);
`;

const CityDot = styled.div`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #fff;
  box-shadow: 0 0 12px #fff, 0 0 24px #2640ed66;
  animation: cityDotBlink 1.2s infinite alternate;
  opacity: 0.85;
  margin-bottom: 2px;
  @keyframes cityDotBlink {
    0% {
      opacity: 0.5;
      box-shadow: 0 0 8px #fff, 0 0 16px #2640ed33;
      transform: scale(1);
    }
    100% {
      opacity: 0.8;
      box-shadow: 0 0 24px #fff, 0 0 48px #2640ed99;
      transform: scale(1.6);
    }
  }
`;

const CityDotLabel = styled.div`
  font-size: 13px;
  color: #fff;
  text-shadow: 0 1px 6px #2640ed99;
  font-weight: 500;
  margin-top: 2px;
  white-space: nowrap;
`;

const CityList = styled.div`
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%) translateX(50%);
  background: rgba(23, 46, 104, 0.63);
  box-shadow: 0 4px 32px rgba(0, 0, 0, 0.1);
  border-radius: 18px;
  padding: 32px 36px 24px 36px;
  min-width: 320px;
  max-width: 90%;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: center;
  z-index: 2;
`; // 省名 styled-component
const ProvinceName = styled.span`
  font-weight: 700;
  color: #fff;
  font-size: 16px;
  min-width: 72px;
  margin-top: 2px;
`;

// 城市内容 styled-component
const CityNames = styled.span`
  color: #fff;
  font-size: 15px;
  display: block;
  width: 180px;
  line-height: 28px;
  word-break: break-all;
  white-space: normal;
`;
// 省份块 styled-component
const ProvinceBlock = styled.div<{ $hasLine: boolean }>`
  width: 100%;
  display: flex;
  align-items: flex-start;
  padding: 4px;
  border-bottom: ${({ $hasLine }) =>
    $hasLine ? "1px solid rgba(255,255,255,0.18)" : "none"};
`;
const IntroStats = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-top: 18px;
  width: 100%;
  gap: 12px 0;
`;

const IntroStat = styled.div`
  flex: 0 0 50%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-top: 53px;
`;

const IntroStatNum = styled.span`
  font-size: 40px;
  font-weight: 700;
  color: #7b8cff;
  margin-bottom: 2px;
`;

const IntroStatUnit = styled.span`
  font-size: 14px;
  color: #7b8cff;
  margin-left: 2px;
`;

const IntroStatLabel = styled.div`
  font-size: 13px;
  color: #e0e6f6;
`;
// 简介信息卡片 styled-component
const IntroCard = styled.div`
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%) translateX(-50%);
  border-radius: 0;
  width: 344px;
  color: #fff;
  z-index: 2;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

// 新疆、陕西、内蒙古、山西、山东、安徽、江苏、浙江、福建
// 坐标为大致估算，基于中国地图图片的像素，左上为(0,0)
  const cityDotPositions = [
    { left: 180, top: 251, label: "新疆" },      // 新疆（西北角偏下）
    { left: 415, top: 358, label: "陕西" },     // 陕西（中西部偏下）
    { left: 498, top: 247, label: "内蒙古" },   // 内蒙古（北部偏左）
    { left: 498, top: 320, label: "山西" },     // 山西（中部偏左）
    { left: 604, top: 329, label: "山东" },     // 山东（中部偏右上）
    { left: 566, top: 388, label: "安徽" },     // 安徽（中部偏右下）
    { left: 623, top: 393, label: "江苏" },     // 江苏（中部偏右）
    { left: 628, top: 449, label: "浙江" },     // 浙江（东南部）
    { left: 596, top: 496, label: "福建" },     // 福建（东南沿海）
  ];
export default function Cities() {
  return (
    <CitiesSection>
      <CitiesContainer>
        <SectionTitle className="white-text">入驻城市</SectionTitle>
        <SectionSubtitle className="white-text">Resident City</SectionSubtitle>
        <CityMap>
          {/* 小圆点城市高亮+名称 */}
          {cityDotPositions.map((pos, idx) => (
            <CityDotWrap key={idx} style={{ left: pos.left, top: pos.top }}>
              <CityDot style={{ animationDelay: `${Math.random() * 1.2}s` }} />
              <CityDotLabel>{pos.label}</CityDotLabel>
            </CityDotWrap>
          ))}
          <IntroCard>
            <div style={{ fontSize: 14, lineHeight: "26px" }}>{INTRO_TEXT}</div>
            <IntroStats>
              {INTRO_STATS.map((stat) => (
                <IntroStat key={stat.label}>
                  <IntroStatNum>
                    {stat.num}
                    {stat.unit && <IntroStatUnit>{stat.unit}</IntroStatUnit>}
                  </IntroStatNum>
                  <IntroStatLabel>{stat.label}</IntroStatLabel>
                </IntroStat>
              ))}
            </IntroStats>
          </IntroCard>
          <CityList>
            {CITY_GROUPS.map((group, idx) => (
              <ProvinceBlock
                key={group.province}
                $hasLine={idx !== CITY_GROUPS.length - 1}
              >
                <ProvinceName>{group.province}：</ProvinceName>
                <CityNames>{group.cities}</CityNames>
              </ProvinceBlock>
            ))}
          </CityList>
        </CityMap>
      </CitiesContainer>
    </CitiesSection>
  );
}
